var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _rect, _rect2, _mask, _path, _mask2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkillsImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 349,
    height: 283,
    viewBox: "0 0 349 283",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 40,
    r: 2,
    fill: "#ABB2BF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.75,
    cy: 40,
    r: 2,
    fill: "#ABB2BF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 40,
    r: 2,
    fill: "#ABB2BF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.25,
    cy: 40,
    r: 2,
    fill: "#ABB2BF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 40,
    r: 2,
    fill: "#ABB2BF"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 54.75,
    r: 2,
    fill: "#ABB2BF"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.75,
    cy: 54.75,
    r: 2,
    fill: "#ABB2BF"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 54.75,
    r: 2,
    fill: "#ABB2BF"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.25,
    cy: 54.75,
    r: 2,
    fill: "#ABB2BF"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 54.75,
    r: 2,
    fill: "#ABB2BF"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 69.5,
    r: 2,
    fill: "#ABB2BF"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.75,
    cy: 69.5,
    r: 2,
    fill: "#ABB2BF"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 69.5,
    r: 2,
    fill: "#ABB2BF"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.25,
    cy: 69.5,
    r: 2,
    fill: "#ABB2BF"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 69.5,
    r: 2,
    fill: "#ABB2BF"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 84.25,
    r: 2,
    fill: "#ABB2BF"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.75,
    cy: 84.25,
    r: 2,
    fill: "#ABB2BF"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 84.25,
    r: 2,
    fill: "#ABB2BF"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.25,
    cy: 84.25,
    r: 2,
    fill: "#ABB2BF"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 84.25,
    r: 2,
    fill: "#ABB2BF"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 99,
    r: 2,
    fill: "#ABB2BF"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.75,
    cy: 99,
    r: 2,
    fill: "#ABB2BF"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 99,
    r: 2,
    fill: "#ABB2BF"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.25,
    cy: 99,
    r: 2,
    fill: "#ABB2BF"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 99,
    r: 2,
    fill: "#ABB2BF"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 179,
    cy: 145,
    r: 2,
    fill: "#ABB2BF"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 193.75,
    cy: 145,
    r: 2,
    fill: "#ABB2BF"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 208.5,
    cy: 145,
    r: 2,
    fill: "#ABB2BF"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 223.25,
    cy: 145,
    r: 2,
    fill: "#ABB2BF"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 238,
    cy: 145,
    r: 2,
    fill: "#ABB2BF"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 179,
    cy: 159.75,
    r: 2,
    fill: "#ABB2BF"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 193.75,
    cy: 159.75,
    r: 2,
    fill: "#ABB2BF"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 208.5,
    cy: 159.75,
    r: 2,
    fill: "#ABB2BF"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 223.25,
    cy: 159.75,
    r: 2,
    fill: "#ABB2BF"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 238,
    cy: 159.75,
    r: 2,
    fill: "#ABB2BF"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 179,
    cy: 174.5,
    r: 2,
    fill: "#ABB2BF"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 193.75,
    cy: 174.5,
    r: 2,
    fill: "#ABB2BF"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 208.5,
    cy: 174.5,
    r: 2,
    fill: "#ABB2BF"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 223.25,
    cy: 174.5,
    r: 2,
    fill: "#ABB2BF"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 238,
    cy: 174.5,
    r: 2,
    fill: "#ABB2BF"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 179,
    cy: 189.25,
    r: 2,
    fill: "#ABB2BF"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 193.75,
    cy: 189.25,
    r: 2,
    fill: "#ABB2BF"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 208.5,
    cy: 189.25,
    r: 2,
    fill: "#ABB2BF"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 223.25,
    cy: 189.25,
    r: 2,
    fill: "#ABB2BF"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 238,
    cy: 189.25,
    r: 2,
    fill: "#ABB2BF"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 179,
    cy: 204,
    r: 2,
    fill: "#ABB2BF"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 193.75,
    cy: 204,
    r: 2,
    fill: "#ABB2BF"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 208.5,
    cy: 204,
    r: 2,
    fill: "#ABB2BF"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 223.25,
    cy: 204,
    r: 2,
    fill: "#ABB2BF"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 238,
    cy: 204,
    r: 2,
    fill: "#ABB2BF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 297.5,
    y: 193.5,
    width: 51,
    height: 51,
    stroke: "#ABB2BF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 227.5,
    y: 0.5,
    width: 85,
    height: 85,
    stroke: "#ABB2BF"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-53-inside-1_29_371",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.5 169H99.75H128V197.25V225.5V253.75H99.75H71.5V225.5H99.75V197.25H71.5V169Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.5 169V168H70.5V169H71.5ZM128 169H129V168H128V169ZM128 253.75V254.75H129V253.75H128ZM71.5 253.75H70.5V254.75H71.5V253.75ZM71.5 225.5V224.5H70.5V225.5H71.5ZM99.75 225.5V226.5H100.75V225.5H99.75ZM99.75 197.25H100.75V196.25H99.75V197.25ZM71.5 197.25H70.5V198.25H71.5V197.25ZM99.75 168H71.5V170H99.75V168ZM128 168H99.75V170H128V168ZM129 197.25V169H127V197.25H129ZM129 225.5V197.25H127V225.5H129ZM129 253.75V225.5H127V253.75H129ZM99.75 254.75H128V252.75H99.75V254.75ZM99.75 252.75H71.5V254.75H99.75V252.75ZM72.5 253.75V225.5H70.5V253.75H72.5ZM71.5 226.5H99.75V224.5H71.5V226.5ZM98.75 197.25V225.5H100.75V197.25H98.75ZM71.5 198.25H99.75V196.25H71.5V198.25ZM70.5 169V197.25H72.5V169H70.5Z",
    fill: "#C778DD",
    mask: "url(#path-53-inside-1_29_371)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-55-outside-2_29_371",
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 196.25,
    width: 59,
    height: 87,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 14,
    y: 196.25,
    width: 59,
    height: 87
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 197.25H43.25H71.5V225.5H43.25V253.75H71.5V282H43.25H15V253.75V225.5V197.25Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 197.25V196.25H14V197.25H15ZM71.5 197.25H72.5V196.25H71.5V197.25ZM71.5 225.5V226.5H72.5V225.5H71.5ZM43.25 225.5V224.5H42.25V225.5H43.25ZM43.25 253.75H42.25V254.75H43.25V253.75ZM71.5 253.75H72.5V252.75H71.5V253.75ZM71.5 282V283H72.5V282H71.5ZM15 282H14V283H15V282ZM43.25 196.25H15V198.25H43.25V196.25ZM71.5 196.25H43.25V198.25H71.5V196.25ZM72.5 225.5V197.25H70.5V225.5H72.5ZM43.25 226.5H71.5V224.5H43.25V226.5ZM44.25 253.75V225.5H42.25V253.75H44.25ZM43.25 254.75H71.5V252.75H43.25V254.75ZM70.5 253.75V282H72.5V253.75H70.5ZM71.5 281H43.25V283H71.5V281ZM15 283H43.25V281H15V283ZM14 253.75V282H16V253.75H14ZM14 225.5V253.75H16V225.5H14ZM14 197.25V225.5H16V197.25H14Z",
    fill: "#C778DD",
    mask: "url(#path-55-outside-2_29_371)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillsImg);
export default __webpack_public_path__ + "static/media/skills-img.46ea80594672b56e0107b784a736a631.svg";
export { ForwardRef as ReactComponent };